import aliancaLogo from '../assets/alianca-logo-negativo.svg';

const UnauthorizedPage = () => (
  <div
    className="mds-flex mds-flex-column mds-secondary__background-color mds-secondary__on-background-color"
    style={{
      alignItems: 'center',
      height: '100vh',
      justifyContent: 'space-evenly',
      padding: '2rem',
    }}
  >
    <div
      className="mds-flex mds-flex-column mds-gap-500"
      style={{ alignItems: 'center' }}
    >
      <h3>Acesso negado!</h3>
      <p style={{ textAlign: 'center' }}>
        Você não tem permissão para acessar este recurso.
      </p>
    </div>

    <img
      src={aliancaLogo}
      alt="Aliança - A Maersk Company"
      style={{ maxWidth: '100%', width: 'auto' }}
    />
  </div>
);

export default UnauthorizedPage;
